import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@uplift/ui-v2';

const useStyles = makeStyles()((theme) => ({
  root: {
    maxWidth: 700,
    width: '100%',
    margin: '0 auto',
    padding: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  icon: {
    marginBottom: theme.spacing(2),
    '& svg': {
      fontSize: 56,
    },
  },
  actions: {
    marginTop: theme.spacing(4),
  },
}));

export type FinalStepProps = {
  icon?: ReactNode;
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
};

export const FinalStep = ({ icon, title, description, actionLabel, onAction }: FinalStepProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      {icon && <Box className={classes.icon}>{icon}</Box>}
      <Typography variant="h4" fontWeight={700} gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary">{description}</Typography>
      <Box className={classes.actions}>
        <Button variant="contained" color="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      </Box>
    </Box>
  );
};
